import * as React from 'react';
import {
  MergeOrder,
  TopModelMergeNameTransformed,
} from '@goldwasserexchange/react-topmodel';
import { yesNoInputDomDefaultTopModelsObject } from './topmodels';

export function DefaultYesNoInputDomTopModelsProvider(
  props: React.PropsWithChildren<{ order?: MergeOrder }>,
) {
  const { children, order } = props;
  return (
    <TopModelMergeNameTransformed
      topModels={yesNoInputDomDefaultTopModelsObject}
      order={order}
    >
      {children}
    </TopModelMergeNameTransformed>
  );
}
